import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Python from '@/components/Python'
import Java from '@/components/Java'
import Android from '@/components/Android'
import Php from '@/components/Php'
import Nodejs from '@/components/Nodejs'
import Html from '@/components/Html'
import Team from '@/components/Team'
import Cv from '@/components/Cv'
import Experience from '@/components/Experience'
import CSharp from '@/components/CSharp'
import MachineLearning from '@/components/MachineLearning'
import DevOps from '@/components/DevOps'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/python',
      name: 'Python',
      component: Python
    },
    {
      path: '/java',
      name: 'Java',
      component: Java
    },
    {
      path: '/android',
      name: 'Android',
      component: Android
    },
    {
      path: '/php',
      name: 'Php',
      component: Php
    },
    {
      path: '/nodejs',
      name: 'Nodejs',
      component: Nodejs
    },
    {
      path: '/html',
      name: 'Html',
      component: Html
    },
    {
      path: '/team',
      name: 'Team',
      component: Team
    },
    {
      path: '/cv',
      name: 'Cv',
      component: Cv
    },
    {
      path: '/experience',
      name: 'Experience',
      component: Experience
    },
    {
      path: '/csharp',
      name: 'CSharp',
      component: CSharp
    },
    {
      path: '/ml',
      name: 'MachineLearning',
      component: MachineLearning
    },
    {
      path: '/devops',
      name: 'DevOps',
      component: DevOps
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js